import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box, Chip } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
    children?: React.ReactNode;
    tabIndex?: number;
    tabValue: number;
}

class DiversionHeader extends React.Component<RouteComponentProps & WithTranslation& IProps, IState> {
    constructor(props: RouteComponentProps & WithTranslation& IProps) {
        super(props);
        let current_path = this.props.location.pathname.split('/');
        let activeTab = 0;
        if (current_path[1] == 'diversion') {
            activeTab = 0;
        } else if (current_path[1] == 'incoming-waste' || current_path[1] == 'incoming-waste-charts') {
            activeTab = 1;
        } else if (current_path[1] == 'diverted-waste' || current_path[1] == 'diverted-waste-charts') {
            activeTab = 2;
        } else if (current_path[1] == 'outgoing-waste' || current_path[1] == 'outgoing-waste-charts') {
            activeTab = 3;
        }else if (current_path[1] == 'inventory' &&
         (process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(',') || []).includes(this.props.user.email)) {
            activeTab = 4;
        }else if (current_path[1] === 'buyers') {
            activeTab = (process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(',') || []).includes(this.props.user.email) ? 5 : 4;
        }
        this.state = {
            tabValue: activeTab
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            if (newValue == 0) {
                this.props.history.push('/diversion')
            } else if (newValue == 1) {
                this.props.history.push('/incoming-waste')
            } else if (newValue == 2) {
                this.props.history.push('/diverted-waste')
            } else if (newValue == 3) {
                this.props.history.push('/outgoing-waste')
            }else if (newValue == 4) {
                if ((process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(',') || []).includes(this.props.user.email)) {
                  this.props.history.push('/inventory')
                }else {
                    this.props.history.push('/buyers');
                }
            } else if (
                newValue === ((process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(',') || []).includes(this.props.user.email) ? 5 : 4)
            ) {
                this.props.history.push('/buyers');
            }
        };
        return (
            <div>
                <Typography variant="h4" className='page-title'>{t("Diversion")}</Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="OverView" />
                        <Tab label="Incoming Waste" />
                        <Tab label="Diverted Waste" />
                        <Tab label="Outgoing Waste" />
                        {
                             (process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(',') || []).includes(this.props.user.email) && (
                                 <Tab label="Inventory" />
                             )
                        }
                       <Tab label="Buyers" />
                    </Tabs>
                </Box>
            </div>
        )
    }
}

export default withRouter(withTranslation()(DiversionHeader))